import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as common from '../../../../../../../../common'
import * as enums from '../../../../../enums'
import * as jobTitle from '../job-title'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    constraints: {
      acceptable: common.DaCategory.ForEmployee.ALL,
    },
    context: core.dms.models.Attribute.Id.Context.from({
      context: jobTitle.RESOURCE.payload.dimension.partialId,
      partialId: jobTitle.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: false,
    name: 'Library User Category',
    partialId: PartialId.Standard.create('lib_usr_cat'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.libraryUserCategory.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
